// Shared contract + helpers for cloud import providers (Dropbox today, OneDrive later).
//
// Every provider implements this shape so the native pickers stay provider-agnostic.
// Nothing downstream cares which provider produced a File.
//
// CloudProvider = {
//   id,                                                       // CLOUD_PROVIDER value
//   label,                                                    // human label for buttons
//   isEnabled(),                                              // config present
//   loadPicker(),                                             // lazy-load the native chooser script
//   openFilePicker({ accept, multiselect, onSelection }),     // native file chooser
//   downloadSelection(selection),                            // chooser selection -> Promise<File[]>
//   openFolderPicker({ multiselect, onSelection }),          // native file+folder chooser
//   downloadFolderSelection(selection),                      // chooser selection -> Promise<File[]>
// }

const extensionMimeMap = {
  '.pdf': 'application/pdf',
  '.png': 'image/png',
  '.jpg': 'image/jpeg',
  '.jpeg': 'image/jpeg',
  '.heic': 'image/heic',
  '.heif': 'image/heif',
  '.doc': 'application/msword',
  '.docx': 'application/vnd.openxmlformats-officedocument.wordprocessingml.document'
};

export const inferFileTypeFromName = (fileName = '') => {
  const lower = fileName.toLowerCase();
  const match = Object.keys(extensionMimeMap).find((ext) => lower.endsWith(ext));
  return match ? extensionMimeMap[match] : '';
};
